import React from 'react';
import { Link } from 'react-router-dom';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';

const PageNotFound = (props) => {
  return (
    <>
      <SiteMetaData />
      <div
        className="blue-background terms-of-use"
        style={{
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div className="container" style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
          <h1 style={{ textAlign: 'center' }}>Sorry, page not found!</h1>
          <button style={{ margin: 'auto' }}>
            <Link to={'/'}>Click to go to the homepage</Link>
          </button>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
